export default {"src":"https://assets.willie.be/c0aaa858cfc53493/_next/static/media/minus.fb017936.svg","height":3,"width":14,"blurWidth":0,"blurHeight":0};